/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type PdpSharedShippingInfoLink_shipmentQuote$ref = any;
export type PdpSharedShippingInfoLink_shipmentQuote = {
    readonly isCustom: boolean | null;
    readonly isNew: boolean | null;
    readonly status: string | null;
    readonly " $refType": PdpSharedShippingInfoLink_shipmentQuote$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpSharedShippingInfoLink_shipmentQuote",
    "type": "ShipmentQuote",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "isCustom",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "isNew",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "status",
            "args": null,
            "storageKey": null
        }
    ]
} as any);
(node as any).hash = '904e872823396a128469f00e8319c6cb';
export default node;
